import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button, Modal, ModalActions, ModalContent } from '@uplift/ui-v2';

export type FinishSubmittingSessionsModalProps = {
  unsubmittedSessionsCount: number;
  open: boolean;
  onClose: (proceed: boolean) => void;
};

export const FinishSubmittingSessionsModal: React.VFC<FinishSubmittingSessionsModalProps> = props => {
  const { classes } = useFinishSubmittingSessionsModalStyles();

  const message = props.unsubmittedSessionsCount === 1
    ? 'This client still has a session that you must submit or resolve before you can add a discharge note.'
    : `This client still has ${props.unsubmittedSessionsCount} sessions that you must submit or resolve before you can add a discharge note.`;

  const buttonCopy = props.unsubmittedSessionsCount === 1
    ? 'Resolve session'
    : 'Resolve sessions';

  return (
    <Modal
      open={props.open}
      maxWidth="md"
      fullWidth
      showCloseIcon
      title="Finish submitting your sessions"
      onClose={() => props.onClose(false)}
    >
      <ModalContent classes={{ root: classes.modalContent }}>
        <Typography>{message}</Typography>
      </ModalContent>
      <ModalActions>
        <Button color="secondary" variant="contained" onClick={() => props.onClose(true)}>{buttonCopy}</Button>
      </ModalActions>
    </Modal>
  );
};

const useFinishSubmittingSessionsModalStyles = makeStyles({ name: 'FinishSubmittingSessionsModal' })(theme => ({
  modalContent: {
    paddingBottom: theme.spacing(5)
  }
}));
